// Contexto del chat de soporte (Zendesk Messaging Web Widget, cargado en public/index.html).
// Los campos deben existir en Zendesk como campos de ticket editables por el usuario final;
// si un ID no está configurado, ese campo simplemente no se envía.
const FIELD_IDS = {
  clientName: process.env.VUE_APP_ZENDESK_FIELD_CLIENT_NAME,
  clientNit: process.env.VUE_APP_ZENDESK_FIELD_CLIENT_NIT,
  userId: process.env.VUE_APP_ZENDESK_FIELD_USER_ID,
}

// El widget puede no cargar (bloqueadores de anuncios, red); el portal no debe fallar por eso.
function zendesk(...args) {
  if (typeof window.zE !== 'function') return
  window.zE(...args)
}

// Zendesk aplica campos y etiquetas al crear el ticket de la conversación,
// por eso se envían apenas se conoce al usuario.
export function setChatContext(user) {
  const client = user.client || {}
  const values = {
    clientName: client.name,
    clientNit: client.nit,
    userId: user.id,
  }

  const fields = Object.keys(FIELD_IDS)
    .filter(key => FIELD_IDS[key] && values[key] !== null && values[key] !== undefined && values[key] !== '')
    .map(key => ({ id: FIELD_IDS[key], value: String(values[key]) }))

  if (fields.length) zendesk('messenger:set', 'conversationFields', fields)

  const tags = ['portal_clientes']
  if (client.id) tags.push(`cliente_${client.id}`)
  zendesk('messenger:set', 'conversationTags', tags)
}

// Borra la conversación, los campos y las etiquetas guardados en el navegador,
// para que el siguiente usuario del equipo no vea el chat del anterior.
export function resetChat() {
  zendesk('messenger', 'resetWidget', () => {})
}
